import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=69960fa6&scoped=true&"
import script from "./ProductSearch.vue?vue&type=script&lang=js&"
export * from "./ProductSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69960fa6",
  null
  
)

export default component.exports